import { Subject } from 'rxjs';

export class EntidadeSharedDataService {

  private updateList = new Subject<boolean>();
  updateList$ = this.updateList.asObservable();

  private updateObjEntidade = new Subject<any>();
  updateObjEntidade$ = this.updateObjEntidade.asObservable();

  private updateDadosBasico = new Subject<any>();
  updateDadosBasico$ = this.updateDadosBasico.asObservable();

  private updateDadosContato = new Subject<any>();
  updateDadosContato$ = this.updateDadosContato.asObservable();

  private updateObservacao = new Subject<any>();
  updateObservacao$ = this.updateObservacao.asObservable();

  private updatedocumento = new Subject<any>();
  updatedocumento$ = this.updatedocumento.asObservable();

  private updateGrupos = new Subject<any>();
  updateGrupos$ = this.updateGrupos.asObservable();

  private resetForm = new Subject<any>();
  resetForm$ = this.resetForm.asObservable();

  private updateEmpresaEstrangeira = new Subject<boolean>();
  updateEmpresaEstrangeira$ = this.updateEmpresaEstrangeira.asObservable();

  constructor() { }

  public setUpdateList(data: boolean): void {
    this.updateList.next(data);
  }

  public setUpdateObjEntidade(data: any): void {
    this.updateObjEntidade.next(data);
  }

  public setUpdateDadosBasico(data: any): void {
    this.updateDadosBasico.next(data);
  }

  public setUpdateDadosContato(data: any): void {
    this.updateDadosContato.next(data);
  }

  public setObservacao(data: any): void {
    this.updateObservacao.next(data);
  }

  public setGrupos(data: any): void {
    this.updateGrupos.next(data);
  }

  public setDocumento(data: any): void {
    this.updatedocumento.next(data);
  }

  public setResetForm(data: any): void {
    this.resetForm.next(data);
  }

  public setEmpresaEstrangeira(data: any): void {
    this.updateEmpresaEstrangeira.next(data);
  }
}
